module.exports = __webpack_public_path__ + "media/header-video.aca7dcaf.mp4";